module.exports = __webpack_public_path__ + "img/xiaohui1.919f6bd3.jpg";